import { createFileRoute } from '@tanstack/react-router';
import { AdminUserDetailScreen } from '@/features/admin/AdminUserDetailScreen';

export const Route = createFileRoute('/_app/admin/users/$userId')({
  component: () => {
    const { userId } = Route.useParams();
    return <AdminUserDetailScreen userId={Number(userId)} />;
  },
});
